import { render } from "./help-center.svg?vue&type=template&id=6d4c9caf"
const script = {}
script.render = render

export default script